const getSelectedShapeRGBs = (ims, rgbs, nose_rgbs, forehead_rgbs, cheek1_rgbs, cheek2_rgbs, timestamp) => {
    let r = 0, g = 0, b = 0, count = 0;
    let nose_r = 0, nose_g = 0, nose_b = 0, nose_count = 0;
    let forehead_r = 0, forehead_g = 0, forehead_b = 0, forehead_count = 0;
    let cheek1_r = 0, cheek1_g = 0, cheek1_b = 0, cheek1_count = 0;
    let cheek2_r = 0, cheek2_g = 0, cheek2_b = 0, cheek2_count = 0;

    let newTimeStamp = performance.now();
    let frameTimeStamp = timestamp;
    frameTimeStamp.push(newTimeStamp);

    for (let s = 0; s < ims.length; s++) {
        let imData = ims[s];

        for(let i = 0; i < imData.length; i += 4) {
            r += imData[i];
            g += imData[i + 1];
            b += imData[i + 2];
            count++;

            if(s==0) {
                nose_r += imData[i];
                nose_g += imData[i + 1];
                nose_b += imData[i + 2];
                nose_count++;
            }

            if(s==1) {
                forehead_r += imData[i];
                forehead_g += imData[i + 1];
                forehead_b += imData[i + 2];
                forehead_count++;
            }

            if(s==2) {
                cheek1_r += imData[i];
                cheek1_g += imData[i + 1];
                cheek1_b += imData[i + 2];
                cheek1_count++;
            }

            if(s==3) {
                cheek2_r += imData[i];
                cheek2_g += imData[i + 1];
                cheek2_b += imData[i + 2];
                cheek2_count++;
            }
        }
    }

    if (count !== 0) {
        r = r / count;
        g = g / count;
        b = b / count;

        let R = rgbs["r"];
        let G = rgbs["g"];
        let B = rgbs["b"];

        R.push(r);
        G.push(g);
        B.push(b);

        //nose
        nose_r = nose_r / nose_count;
        nose_g = nose_g / nose_count;
        nose_b = nose_b / nose_count;

        let nose_R = nose_rgbs["r"];
        let nose_G = nose_rgbs["g"];
        let nose_B = nose_rgbs["b"];

        nose_R.push(nose_r);
        nose_G.push(nose_g);
        nose_B.push(nose_b);

        //forehead
        forehead_r = forehead_r / forehead_count;
        forehead_g = forehead_g / forehead_count;
        forehead_b = forehead_b / forehead_count;

        let forehead_R = forehead_rgbs["r"];
        let forehead_G = forehead_rgbs["g"];
        let forehead_B = forehead_rgbs["b"];

        forehead_R.push(forehead_r);
        forehead_G.push(forehead_g);
        forehead_B.push(forehead_b);

        //cheek1
        cheek1_r = cheek1_r / cheek1_count;
        cheek1_g = cheek1_g / cheek1_count;
        cheek1_b = cheek1_b / cheek1_count;

        let cheek1_R = cheek1_rgbs["r"];
        let cheek1_G = cheek1_rgbs["g"];
        let cheek1_B = cheek1_rgbs["b"];

        cheek1_R.push(cheek1_r);
        cheek1_G.push(cheek1_g);
        cheek1_B.push(cheek1_b);

        //cheek2
        cheek2_r = cheek2_r / cheek2_count;
        cheek2_g = cheek2_g / cheek2_count;
        cheek2_b = cheek2_b / cheek2_count;

        let cheek2_R = cheek2_rgbs["r"];
        let cheek2_G = cheek2_rgbs["g"];
        let cheek2_B = cheek2_rgbs["b"];

        cheek2_R.push(cheek2_r);
        cheek2_G.push(cheek2_g);
        cheek2_B.push(cheek2_b);

        return {
            rgbs: {
                "r": R,
                "g": G,
                "b": B,
            },
            nose_rgbs: {
                "r": nose_R,
                "g": nose_G,
                "b": nose_B,
            },
            forehead_rgbs: {
                "r": forehead_R,
                "g": forehead_G,
                "b": forehead_B,
            },
            cheek1_rgbs: {
                "r": cheek1_R,
                "g": cheek1_G,
                "b": cheek1_B,
            },
            cheek2_rgbs: {
                "r": cheek2_R,
                "g": cheek2_G,
                "b": cheek2_B,
            },
            timestamp: frameTimeStamp
        }
    }
};

export default getSelectedShapeRGBs;